// extracted by mini-css-extract-plugin
export var orderSummary = "_jv-0";
export var showMoreLessButton = "_jv-1";